import React from 'react';
import MultistorePlaceCardOrderTypes from "./MultistorePlaceCardOrderTypes";
import {PlaceApi} from "../../../../../../services/Api/types";
import {ReactComponent as PatternIco} from "../../../../../../../images/backgrounds/multistore/card-place-pattern.svg";

interface Props {
    place: PlaceApi;
}

const MultistorePlaceCardCover = ({place}: Props) => {
    return (
        <div className="place-card-cover">
            <div className={`cover-bg`}
                 style={{backgroundImage: `url("${place.cover_small}")`}}>
                {!place.cover_small && <PatternIco className="pattern-ico"/>}
            </div>
            <div className="cover-content">
                <div className="place-card-cover-top">
                    <MultistorePlaceCardOrderTypes orderTypes={place.types}/>
                </div>
                <div className="place-card-cover-bottom">
                    {place.cover_small && <div className="bottom-blur"/>}
                    {place.logo_small && (
                        <div className="logo" style={{backgroundImage: `url("${place.logo_small}")`}}></div>
                    )}
                    <div className="d-flex flex-column justify-content-center place-info-container">
                        <h1 className={place.header ? "" : "multiline"}>{place.name}</h1>
                        {place.header && <p>{place.header}</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MultistorePlaceCardCover;